/**
 * Scrim — `DESIGN-HANDOVER.md` §5.8. Flat `#00000080`, no border, no blur.
 *
 * INFERENCE, flagged: the sampled frame is `300x300`. That it covers the full viewport in
 * product use is a reasonable read of what a scrim is for, but it is NOT directly evidenced.
 */
export function Scrim({ onClick, className }: { onClick?: () => void; className?: string }) {
  return (
    <div
      aria-hidden
      onClick={onClick}
      className={`fixed inset-0 bg-overlay-scrim${className ? ` ${className}` : ''}`}
    />
  )
}
